<div>
	<div>
		<h4>Most Searched Products</h4>
	</div>

	<!-- Loading State -->
	<div *ngIf="loading" class="flex justify-content-center align-items-center p-4">
		<mat-spinner [diameter]="50"></mat-spinner>
	</div>

	<!-- Empty State -->
	<div *ngIf="!loading && isEmpty" class="flex justify-content-center align-items-center p-4">
		<div class="text-center">
			<i class="pi pi-inbox text-4xl text-400 mb-3"></i>
			<p class="text-600">No data available for this period.</p>
		</div>
	</div>

	<!-- Data Table -->
	<table
		*ngIf="!loading && !isEmpty"
		mat-table
		[dataSource]="mostSearchedDataSource"
		matSort
		(matSortChange)="onSearchedProductsSortChange($event)"
	>
		<!-- Product Name Column -->
		<ng-container matColumnDef="ProductName">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Search Keyword</th>
			<td mat-cell *matCellDef="let element">{{ element.ProductName }}</td>
		</ng-container>

		<!-- Search Quantity Column -->
		<ng-container matColumnDef="SearchQuantity">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Search Quantity</th>
			<td mat-cell *matCellDef="let element">
				{{ element.SearchQuantity }}
			</td>
		</ng-container>

		<!-- Conversions Column -->
		<ng-container matColumnDef="Conversions">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Conversions</th>
			<td mat-cell *matCellDef="let element">{{ element.Conversions }}</td>
		</ng-container>

		<!-- Table Header & Rows -->
		<tr mat-header-row *matHeaderRowDef="mostSearchedDisplayedColumns"></tr>
		<tr
			mat-row
			*matRowDef="let row; columns: mostSearchedDisplayedColumns"
		></tr>
	</table>
</div>
